import { Box, IconButton, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import photoGalleryDialogStyles from './styles/photoGalleryDialogStyles'
import { getStyles } from '../../utils/utils/commonUtils'
import plusLupe from '../../assets/images/photoTools/plusLupe.svg'
import minusLupe from '../../assets/images/photoTools/minusLupe.svg'
import { hand } from '../../assets/images/photoTools/hand.js'
import plusLupeWhite from '../../assets/images/photoTools/plusLupeWhite.svg'
import minusLupeWhite from '../../assets/images/photoTools/minusLupeWhite.svg'
import { handWhite } from '../../assets/images/photoTools/handWhite.js'
import { isAdmin } from '../../services/AccountService'
import downloadBlue from '../../assets/images/photoTools/downloadBlue.svg'
import downloadWhite from '../../assets/images/photoTools/downloadWhite.svg'
const PhotoTools = ({
  setZoom,
  setMoveMode,
  moveMode,
  zoom,
  downloadFunc,
  leftTools = false,
  disabled = false,
}) => {
  const classes = getStyles(photoGalleryDialogStyles)
  const activeColor = leftTools ? 'rgba(0, 0, 0, 0.4)' : '#1199FF'

  useEffect(() => {
    if (!moveMode && !!zoom) {
      setMoveMode(true)
    } else if (zoom === 0) {
      setMoveMode(false)
    }
  }, [zoom])

  return (
    <Box
      sx={{
        ...classes.photoTools,
        right: !leftTools ? '40px' : undefined,
        left: leftTools ? '40px' : undefined,
        top: leftTools ? '60px' : '55px',
        background: leftTools
          ? disabled
            ? 'rgba(0, 0, 0, 0.035)'
            : 'rgba(0, 0, 0, 0.4)'
          : '#FFF',
        backdropFilter: leftTools ? 'blur(10px)' : undefined,
        boxShadow: disabled ? 'none' : '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
      }}
    >
      <IconButton
        sx={{
          ...classes.toolWrapper,
          cursor: zoom === 2 || disabled ? 'default' : 'pointer',
          opacity: zoom === 2 || disabled ? 0.2 : 1,
        }}
        onClick={() => {
          if (zoom !== 2) {
            const newZoom = zoom === 0 ? 1 : 2
            setZoom(newZoom)
          }
        }}
      >
        <img src={leftTools ? plusLupeWhite : plusLupe} alt='plus lupe' />
      </IconButton>

      <IconButton
        sx={{
          ...classes.toolWrapper,
          cursor: zoom ? 'pointer' : 'default',
          opacity: zoom ? 1 : 0.2,
        }}
        onClick={() => {
          const newZoom = zoom === 2 ? 1 : 0
          setZoom(newZoom)
        }}
      >
        <img src={leftTools ? minusLupeWhite : minusLupe} alt='minus lupe' />
      </IconButton>

      <IconButton
        sx={{
          ...classes.toolWrapper,
          cursor: 'default',
          opacity: zoom ? 1 : 0.2,
          background: moveMode ? activeColor : null,
          color: moveMode ? 'white' : '#1199FF',
          '&:hover': {
            background: moveMode ? activeColor : null,
            color: moveMode ? 'white' : '#1199FF',
          },
        }}
      >
        {leftTools ? handWhite : hand}
      </IconButton>

      {isAdmin() && (
        <IconButton
          onClick={downloadFunc}
          sx={{
            ...classes.toolWrapper,
            cursor: disabled ? 'text' : 'pointer',
            opacity: disabled ? 0.2 : 1,
          }}
        >
          <img alt='download' src={leftTools ? downloadWhite : downloadBlue} />
        </IconButton>
      )}
    </Box>
  )
}

export default PhotoTools
